import Vue from 'vue'
import Router from 'vue-router'
// 老师个人中心
import Test from '@/components/Test'
import Trem from '@/components/Trem'
import Login from '@/components/Login'
import Examlist from '@/components/teach/Examlist'
import Addplan from '@/components/teach/Addplan'
import Createpaper from '@/components/teach/Createpaper'
import Questionbank from '@/components/teach/Questionbank'
import Questionlist from '@/components/teach/Questionlist'
import Createquestion from '@/components/teach/Createquestion'
import Studentlist from '@/components/teach/Studentlist'

// 学生
import Studentexamlist from '@/components/student/List'
import Examination from '@/components/student/Examination'
const routerRePush = Router.prototype.push
Router.prototype.push = function (location) {

  return routerRePush.call(this, location).catch(error => error)
}

const routerReplace = Router.prototype.replace
Router.prototype.replace = function (location) {
    return routerReplace.call(this, location).catch(error => error)
}
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login
    },{
      path: '/test',
      name: 'Test',
      component: Test
  },{
    path: '/trem',
    name: 'Trem',
    component: Trem
},{
        path: '/examlist',
        name: 'Examlist',
        component: Examlist
    },{
        path: '/addplan',
        name: 'Addplan',
        component: Addplan
    },{
        path: '/createpaper',
        name: 'Createpaper',
        component: Createpaper
    },{
        path: '/questionbank',
        name: 'Questionbank',
        component: Questionbank
    },{
        path: '/questionlist',
        name: 'Questionlist',
        component: Questionlist
    },{
        path: '/createquestion',
        name: 'Createquestion',
        component: Createquestion
    },{
      path: '/studentlist',
      name: 'Studentlist',
      component:Studentlist
    },{
      path: '/studentexamlist',
      name: 'Studentexamlist',
      component:Studentexamlist
    },{
      path: '/examination',
      name: 'Examination',
      component:Examination
    }
    
  ]
})

